import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import * as fromRoot from '../../../common/reducers';
import * as auth from '../../../common/actions/authentication';
import { Store } from '@ngrx/store';

/**
 * This class represents the lazy loaded HomeComponent.
 */

@Component({
  selector: 'sd-logout',
  template: ``,
})
export class LogoutComponent {
  datas: any = [];
  loginForm: FormGroup;
  model = {};

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router
  ) {}

  ngOnInit() {
    localStorage.clear();
    this.store.dispatch(new auth.LogoutAction());
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/auth/logout.component.ts